module.exports = __webpack_public_path__ + "img/FR24349.dc388e11.png";